export default __webpack_public_path__ + "static/media/pic.e9aba8d1.png";